export default __webpack_public_path__ + "static/media/googlesheets.f9d57ba1.jpg";